export const firebaseConfig = {
    apiKey: "AIzaSyAr-tnxDvQTzaewLLGgNnXBQbxpOHyaUbw",
    authDomain: "ping-board-c2743.firebaseapp.com",
    databaseURL: "https://ping-board-c2743.firebaseio.com",
    projectId: "ping-board-c2743",
    storageBucket: "",
    messagingSenderId: "88261141437",
    appId: "1:88261141437:web:2f8e0157e8751fa84568d4"
}